export default __webpack_public_path__ + "static/media/Sanitario-Discapacitados.21164224.png";